import { I18n } from 'react-redux-i18n';

const idealProfileTypes = {
  0: I18n.t('Based on respondent data'),
  1: I18n.t('Manually configured'),
  2: I18n.t('Questionnaire'),
};

export default idealProfileTypes;
